/**
 * AI Cortex — Public API
 *
 * Re-exports every cortex module so callers can import from a single
 * entry point:
 *
 *   import { classifyDomain, captureInteraction } from '../cortex';
 *
 * @module gibbs/cortex
 */

// Domain Router
export { classifyDomain } from './domainRouter';

// Domain Configuration
export { DOMAIN_CONFIG, getDomainConfig } from './domainConfig';

// Knowledge Capture
export {
    captureInteraction,
    buildCaptureEntry,
    submitFeedback,
    getLastCaptureId,
    setCaptureEndpoint,
} from './knowledgeCapture';

// Graph RAG
export {
    queryGraph,
    hybridRetrieve,
    extractEntities,
    setGraphEndpoint,
} from './graphRAG';

// Policy Guard
export {
    scanForPII,
    guardMessage,
    handleGuardResponse,
} from './policyGuard';
